import React from 'react';
import { uniqueId } from 'lodash-es';
import { Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';

type RoundIconProps = {
  score: string;
  className: string;
};

const RoundIcon = ({ score, className }: RoundIconProps) => {
  return (
    <Box className={className} key={uniqueId('scoreCell_')}>
      <Icon
        size="xs"
        color={Number(score) ? 'state_success' : 'state_error'}
        name={`icons/general/state/${Number(score) ? 'success' : 'canceled'}`}
      />
    </Box>
  );
};

export default RoundIcon;
